import React from 'react'

import {Colors} from '../../../src/components/UI/index.js'

export default class NavBar extends React.Component {
    render() {
        const {children} = this.props

        const style = {
            display: 'flex',
            justifyContent: 'space-around',
            flexShrink: 0,
            alignItems: 'center',
            width: '100%',
            height: 80,
            background: Colors.backgroundNeutral,
            color: Colors.textDark,
            boxShadow: '0 1px 2px 0 rgba(60,64,67,.3), 0 2px 6px 2px rgba(60,64,67,.15)',
            zIndex: 10
        }

        return (
            <div style={style}>
                {children}
            </div>

        )
    }
}
